import { api } from "../index";
import notification from "@/ApiConstance/toast";

export default {
  // 1. Get All Posts
  async AllPosts() {
    return await api.get("/allPost");
  },

  // 2. Add New Post
  async AddPost(payload) {
    return await api.post("/addPost", payload).then((res) => {
      notification.toast("Successfully Added", "success");
      // Redirects to the Post List page after adding
      window.location.href = "/posts"; 
    });
  },

  // 3. Update Post
  async UpdatePost(payload) {
    return await api.post("/updatePost", payload).then((res) => {
      notification.toast("Successfully Updated", "success");
      window.location.href = "/posts";
    });
  },

  // 4. Delete Post
  async DeletePost(id) {
    return await api.delete(`/deletePost/${id}`).then((res) => {
      notification.toast("Successfully Deleted", "success");
      // Reloads the page to remove the deleted item from the view
      window.location.href = "/posts";
    });
  },
};